export default function ToolTip({ text }: { text: string }) {
    return (
        <div
            className="
                absolute top-[100%] left-1/2 -translate-x-1/2
                bg-black text-white rounded-[10px]
                w-fit p-[6px] text-[13px]
                whitespace-nowrap z-10
                opacity-0 group-hover:opacity-100
                transition-opacity duration-200
            "
        >
            {text}
        </div>
    );
}
